<script>
    import { onDestroy, onMount } from "svelte";
    import { PRConnect } from "@projectroom/ui-lib";
    import CharImageModal from "./../components/CharImageModal.svelte";

    export let bot;
    export let scenario;
    let imageUploadRef;
    let scenarioTitleRef;
    let charActionFlag = false;
    let charImageModal;
    onMount(() => {});

    const changeCharAction = (charAction) => {
        scenario.changeCharAction(charAction.id);
    };

    const mouseleaveScenarioTitle = () => {
        scenario.changeTitle(scenarioTitleRef.value);
        scenarioTitleRef.blur();
    };
</script>

<div class="talk-title scenario-title">
    <div class="description-input" on:mouseleave={mouseleaveScenarioTitle}>
        <div class="description-input-form w-form">
            <div
                id="email-form"
                name="email-form"
                data-name="Email Form"
                method="get"
                class="talk-form"
                aria-label="Email Form"
            >
                <input
                    type="text"
                    class="name-text-form story w-input"
                    bind:this={scenarioTitleRef}
                    autofocus="true"
                    maxlength="256"
                    name="name-4"
                    data-name="Name 4"
                    placeholder="섹션명을 입력해주세요."
                    id="name-4"
                    value={scenario.title}
                />
            </div>
        </div>
    </div>
</div>
<div class="charecter-image-wrap wrap-size">
    {#if scenario.charAction}
        <img
            class="charecter-image-edit"
            src="/static/images/ko/character-edit.svg"
            on:click={charImageModal.clickCharActionChange()}
            data-step="1"
        />
        <img
            src={bot.defaultChar
                .getCharAction(scenario.charAction)
                .getImageUrl()}
            style={bot.defaultChar
                .getCharAction(scenario.charAction)
                .getImageCss()}
        />
    {:else}
        <div
            class="image-block pointer"
            on:click={charImageModal.clickImageChoicePopup}
        >
            <img
                src="/static/images/image-upload.svg"
                loading="lazy"
                alt=""
                class="image-149"
            />
            <div class="text-block-100">
                이미지를 업로드해주세요!
            </div>
        </div>
    {/if}
    <input
        accept="image/png, image/jpeg, image/jpg, image/gif"
        bind:this={imageUploadRef}
        type="file"
        name="add"
        on:change={(e) => charImageModal.onImageFileUpload(e, scenario)}
        hidden
    />
</div>
<div class="image-dropdown">
    <div
        data-delay="0"
        data-hover="true"
        class="dropdown-2 w-dropdown"
        style=""
    >
        <div
            class="dropdown-toggle-charecter w-dropdown-toggle"
            id="w-dropdown-toggle-1"
            aria-controls="w-dropdown-list-1"
            aria-haspopup="menu"
            aria-expanded="false"
            role="button"
            tabindex="0"
            on:click={() => (charActionFlag = !charActionFlag)}
        >
            <div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
            {#if scenario.charAction}
                <div class="text-block-26">
                    {bot.defaultChar.getCharAction(scenario.charAction)
                        .actionName || ""}
                </div>
            {:else}
                <div class="text-block-26">이미지 선택하기</div>
            {/if}
        </div>
        <nav
            class="dropdown-list-2 w-dropdown-list"
            class:w--open={charActionFlag}
            id="w-dropdown-list-1"
            aria-labelledby="w-dropdown-toggle-1"
            on:mouseleave={() => (charActionFlag = false)}
        >
            {#each bot.defaultChar.charActionList as charAction}
                <a
                    href="#"
                    class="dropdown-link w-dropdown-link pointer"
                    tabindex="0"
                    on:click={() => changeCharAction(charAction)}
                    >{charAction.actionName}</a
                >
            {/each}
        </nav>
    </div>
    <div
        class="delete-button scenario-char-action"
        on:click={charImageModal.deleteScenarioCharAction}
    ></div>
</div>
<CharImageModal bind:this={charImageModal} {imageUploadRef} {bot} {scenario} />

<style>
    .dropdown-2 {
        width: 100%;
    }

    .wrap-size {
        width: 340px;
        margin: auto;
        min-height: 200px;
        margin-bottom: 4px;
        margin-top: 10px;
    }

    .image-dropdown {
        width: 340px;
        height: auto;
        text-align: left;
        margin: auto;
        position: relative;
    }

    .charecter-image-wrap {
        position: relative;
        border: 2px solid rgba(211, 211, 211, 0.5);
        padding: 15px;
        border-radius: 5px;
    }

    .charecter-image-edit {
        position: absolute;
        right: 15px;
        cursor: pointer;
        width: 60px;
    }

    .image-block {
        height: auto;
    }

    .scenario-char-action {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 10px;
    }

    .scenario-title {
        width: 80%;
        margin: auto;
    }

    .description-input-form {
        width: 100%;
        height: auto;
    }

    .talk-form {
        height: auto;
        border-style: none;
        border-radius: none;
        background-color: white;
    }

    .dropdown-toggle-charecter {
        padding: 4px 20px;
    }

    .dropdown-link {
        width: auto;
    }

    @media screen and (min-width: 1280px) {
        .image-block {
            border: none;
        }
    }
</style>
